export default __webpack_public_path__ + "media/images/dashboard_icons/envelope-open-text-bcacb9ce3b350813a6254d84aeadce91.svg";